import { css } from '@emotion/css';

export const videoMaxWidth = css`
  max-width: 48rem;
`;
